import './App.css';
import Footer from './Footer.js';
import Home from './Views/Home.js';

function App() {
  return (
    <main className='relative overflow-x-hidden'>
      <Home />
      <Footer />
    </main>
  );
}

export default App;
